export default __webpack_public_path__ + "static/media/JCBanner.c916c0f6.png";